








import { Component, Vue } from 'vue-property-decorator';
import Card from '@/components/default/Card.vue';
import ArticleCategoryTable from './ArticleCategoryTable.vue';

@Component({
  components: {
    Card,
    ArticleCategoryTable
  },
})
export default class ArticleCategoryOverviewPage extends Vue {

}
